import React, { useEffect, useState } from "react";
import "../slider/slider.css";
//import { Link } from "react-router-dom";
//import Button from "@mui/material/Button";
import Slider from "react-slick";
import axios from "axios";
import { baseURL } from "../../../constants/url";


function Slide() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseURL}common/banners_api/`)
      .then((res) => {
        setBanners(res.data);
      })
      .catch((err) => {
        console.error("Error fetching banners:", err);
      });
  }, []);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
  };

  return (
    <>
      <div className="container-fluid home_banner">
        <Slider {...settings} className="homeSlider">
          {banners.map((banner) => (
            <div key={banner.id} className="item">
              <div className="slider_banner_img banner_size">
                <img src={banner.image} alt={banner.title} className="w-100" />
              </div>
              <div className="slider_banner_text">
                <h1>
                  {banner.title}
                  {banner.subtitle && (
                    <span className="common_color"> {banner.subtitle}</span>
                  )}
                </h1>
                {/* <div className="common_btn_box"> */}
                  {/* <Button> */}
                    {/* <Link to="/searchproductlist" className="common_btn_shop"> */}
                      {/* Shop Now */}
                    {/* </Link> */}
                  {/* </Button> */}
                {/* </div> */}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
}

export default Slide;
